import { apiRequest } from '@/core';
import { type EventOptions } from '@/types';

export const fetchEventOptionsRequest = async () =>
  apiRequest<EventOptions>({
    endpoint: `api/events/options`,
  });
